<template>
    <div>
        <v-card flat class="pa-1">
            <v-toolbar flat color="#FFF" short>
                <v-toolbar-title>Controle de Acessos</v-toolbar-title>
            </v-toolbar>
            <v-tabs centered>
                <v-tab>
                    <v-icon left>mdi-account</v-icon>
                    Usuários
                </v-tab>
                <v-tab left>
                    <v-icon left>mdi-view-module</v-icon>
                    Módulos
                </v-tab>
                <v-tab left>
                    <v-icon left>mdi-account-details</v-icon>
                    Perfil
                </v-tab>
                <v-tab left>
                    <v-icon left>mdi-apps</v-icon>
                    Aplicativos
                </v-tab>
                <v-tab left>
                    <v-icon left>mdi-account-key</v-icon>
                    Permissões
                </v-tab>
                <v-tab-item  class="ma-0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <acl-usuario :atualizarUsu="atualizarUsu"></acl-usuario>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item class="ma-0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <acl-modulos @atualizarApp="atualizarApp = $event"></acl-modulos>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item class="ma-0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <acl-perfis 
                                @atualizarPermUsu="atualizarPerm = $event, atualizarUsu = $event"
                            ></acl-perfis>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item class="ma-0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <acl-apps 
                                @atualizarPerm="atualizarPerm = $event"
                                :atualizarApp="atualizarApp"></acl-apps>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item class="ma-0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <acl-grant :atualizarPerm="atualizarPerm"></acl-grant>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </v-card>
    </div>
</template>
<script>
    import AclUsuario from '../acl/AclUsuario'
    import AclModulos from '../acl/AclModulos'
    import AclPerfis  from '../acl/AclPerfis'
    import AclApps  from '../acl/AclApps'
    import AclGrant  from '../acl/AclGrant'

    export default {
        components: {
            AclUsuario,
            AclModulos,
            AclPerfis,
            AclApps,
            AclGrant
        },
        name: "Acl",

        data(){
            return{
                
                //variaveis usadas para atualizar componentes
                atualizarApp: 0,
                atualizarPerm: 0,
                atualizarUsu: 0
            }
        },

        created() {
            this.Helpers.verificarToken();
        },
    }
</script>
<style scoped>
</style>